import { Box, Typography } from '@material-ui/core';
import { FC } from 'react';
import React from 'react';

interface SearchedAddressInfoProps {
  address: string;
  coordinates: {
    lat: number;
    lng: number;
  };
}

const SearchedAddressInfo: FC<SearchedAddressInfoProps> = ({ address, coordinates }) => {
  return (
    <Box
      style={{
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        borderRadius: 6,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography
        variant="h6"
        style={{
          fontSize: 18,
          marginBottom: 8,
          marginTop: 0,
          color: '#3c4043',
        }}
      >
        Searched Location
      </Typography>
      <Typography
        style={{
          fontSize: 14,
          lineHeight: 1.6,
          margin: 0,
        }}
      >
        {address}
      </Typography>
      <Typography
        style={{
          fontSize: 14,
          lineHeight: 1.6,
          margin: 0,
        }}
      >
        Coordinates: {coordinates.lat.toFixed(4)}, {coordinates.lng.toFixed(4)}
      </Typography>
    </Box>
  );
};

export default React.memo(SearchedAddressInfo);
